import React, { memo } from 'react';
import Flame from '../../assets/flame.svg';

export default memo(props => <Flame alt="flame" {...props} />);
